const checkIfAgreement = agreement => {
  return !!agreement && agreement.name !== undefined;
};
export const getNameFromAgreement = agreement => {
  if (checkIfAgreement(agreement)) {
    return agreement.name || '';
  }
  return agreement;
};
export const getIdFromAgreement = agreement => {
  if (checkIfAgreement(agreement)) {
    return agreement.id || '';
  }
  return '';
};